import React from "react"
import { HelmetProvider } from "react-helmet-async"

// Data
import { AuthProvider, ThemeProvider, BikeStoreProvider, SubdomainProvider } from "hooks"

// Component
import { AlertRoot, AsideMenuProvider, ModalProvider, DrawerProvider } from "hooks"
import { ModalRoot } from "components/Elements/Modal"
import { DrawerRoot } from "components/Elements/Drawer"

export const Providers = ({ children }) => {
    return (
        <HelmetProvider>
            <AuthProvider>
                <BikeStoreProvider>
                    <SubdomainProvider>
                        <ThemeProvider>
                            <ModalProvider>
                                <DrawerProvider>
                                    <AsideMenuProvider>
                                        <>{children}</>
                                        <DrawerRoot />
                                        <ModalRoot />
                                        <AlertRoot />
                                    </AsideMenuProvider>
                                </DrawerProvider>
                            </ModalProvider>
                        </ThemeProvider>
                    </SubdomainProvider>
                </BikeStoreProvider>
            </AuthProvider>
        </HelmetProvider>
    )
}

export default Providers